// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Y7OnjcJd_v9wxEFf2I1T{width:100%;height:100%;position:absolute}", "",{"version":3,"sources":["webpack://./src/lab2/views/lab-views-renderer.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,WAAA,CACA,iBAAA","sourcesContent":[".labContainer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labContainer": "Y7OnjcJd_v9wxEFf2I1T"
};
export default ___CSS_LOADER_EXPORT___;
